import React, { useMemo } from "react";
import PropTypes from "prop-types";

import TruncatedWithTooltip from "../../../components/TruncatedWithTooltip";
import { formatMobileNumber } from "../../../utils/Helpers";
import { UITable } from "../../../components/ui";

const ClientsTable = ({ rows, labels, pageSize, onRowClick }) => {
  const columns = useMemo(
    () => [
      {
        field: "name",
        headerName: labels.name,
        flex: 1,
        minWidth: 180,
        sortable: false,
        renderCell: (params) => {
          const value = params.value || "-";
          if (value === "-")
            return <span className="MuiDataGrid-cellContent">-</span>;
          return (
            <TruncatedWithTooltip title={value}>
              <span className="MuiDataGrid-cellContent">{value}</span>
            </TruncatedWithTooltip>
          );
        },
      },
      {
        field: "email",
        headerName: labels.email,
        flex: 1,
        minWidth: 220,
        sortable: false,
        renderCell: (params) => {
          const value = params.value || "-";
          if (value === "-")
            return <span className="MuiDataGrid-cellContent">-</span>;
          return (
            <TruncatedWithTooltip title={value}>
              <span className="MuiDataGrid-cellContent">{value}</span>
            </TruncatedWithTooltip>
          );
        },
      },
      {
        field: "phone",
        headerName: labels.mobile,
        flex: 0.9,
        minWidth: 160,
        sortable: false,
        renderCell: (params) => {
          const { phone_number: phoneNumber, country, dial_code: dialCode } =
            params.row || {};
          const formatted = formatMobileNumber(
            phoneNumber,
            country?.dial_code ?? dialCode,
          );
          return formatted ? (
            <span className="company-clients__phone">{formatted}</span>
          ) : (
            "-"
          );
        },
      },
    ],
    [labels],
  );

  return (
    <div className="company-clients__table company-clients__table--clickable">
      <UITable
        rows={rows}
        columns={columns}
        pageSize={pageSize}
        contentSized
        hideFooter
        disableSelectionOnClick
        getRowId={(row) => row.id}
        getRowClassName={() => "company-clients__row"}
        onRowClick={({ row }) => onRowClick(row)}
      />
    </div>
  );
};

ClientsTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  labels: PropTypes.shape({
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    mobile: PropTypes.string.isRequired,
  }).isRequired,
  pageSize: PropTypes.number.isRequired,
  onRowClick: PropTypes.func.isRequired,
};

export default ClientsTable;
